// components/ui/product-list.jsx
import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Minus } from "lucide-react";
import ProductAddonSelector from "./product-addon-selector";

const ProductList = ({
  products,
  loading,
  onUpdateQuantity,
  loadingProducts = {},
  selectedAddons,
  onAddonSelect,
}) => {
  // Simple función para verificar si es un addOn válido
  const hasValidAddOns = (product) => {
   
    // Si no hay addOn, retorna falso
    if (!product.addOn || !Array.isArray(product.addOn)) return false;

    // Si es un array con un solo elemento vacío, retorna falso
    if (product.addOn.length === 1 && product.addOn[0].trim() === '') return false;

    // Verifica si hay opciones válidas no vacías
    return product.addOn.some(option => option && option.trim() !== '');
  };

  const handleClick = (product, action) => {
    // Si no tiene addOns válidos, agregar directamente
    if (!hasValidAddOns(product)) {
      console.log("Sin addon Validos")
      onUpdateQuantity(product.id, action);
      return;
    }

    // Si tiene addOns válidos, verificar selección
    if (selectedAddons[product.id]) {
      console.log("Con addon Validos")
      onUpdateQuantity(product.id, action, selectedAddons[product.id]);
    }
  };

  if (loading) {
    return (
      <div className="px-4 py-8 max-w-4xl mx-auto w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {[1, 2, 3, 4].map((skeleton) => (
            <Card key={skeleton} className="p-4 animate-pulse">
              <div className="w-full h-48 bg-gray-200 rounded-lg mb-4"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
              <div className="h-8 bg-gray-200 rounded"></div>
            </Card>
          ))}
        </div>
      </div>
    );
  }

  if (!products.length) {
    return (
      <div className="px-4 py-8 text-center text-gray-500">
        Selecciona una categoría para ver los productos disponibles
      </div>
    );
  }

  return (
    <div className="px-4 py-8 max-w-4xl mx-auto w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {products.map((product) => {
          const needsSelection = hasValidAddOns(product);

          return (
            <Card key={product.id} className="flex flex-col h-full">
              {product.imageUrl && (
                <div className="relative pb-[75%]">
                  <img
                    src={product.imageUrl}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.parentElement.style.display = "none";
                    }}
                  />
                </div>
              )}
              <div className="p-4 flex flex-col flex-grow">
                <h3 className="font-bold text-lg mb-1">{product.name}</h3>
                {product.description && (
                  <p className="text-gray-600 text-sm mb-2">
                    {product.description}
                  </p>
                )}

                {needsSelection && (
                  <div className="mt-2 mb-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      Selecciona una opción:
                    </p>
                    <ProductAddonSelector
                      options={product.addOn.filter(option => option && option.trim() !== '')}
                      selectedOption={selectedAddons[product.id]}
                      onOptionSelect={(option) => onAddonSelect(product.id, option)}
                    />
                  </div>
                )}

                <div className="flex justify-between items-center mt-auto pt-2">
                  <span className="font-bold text-lg text-orange-500">
                    ${product.price.toFixed(2)}
                  </span>
                  <div className="flex items-center gap-2">
                    {product.quantity > 0 ? (
                      <>
                        <Button
                          variant="outline"
                          size="icon"
                          className="h-8 w-8 rounded-full"
                          onClick={() => handleClick(product, "decrease")}
                          disabled={loadingProducts[product.id]}
                        >
                          {loadingProducts[product.id] ? (
                            <div className="h-4 w-4 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
                          ) : (
                            <Minus className="h-4 w-4" />
                          )}
                        </Button>
                        <span className="w-8 text-center">
                          {product.quantity}
                        </span>
                        <Button
                          variant="outline"
                          size="icon"
                          className="h-8 w-8 rounded-full"
                          onClick={() => handleClick(product, "increase")}
                          disabled={needsSelection && !selectedAddons[product.id] || loadingProducts[product.id]}
                        >
                          {loadingProducts[product.id] ? (
                            <div className="h-4 w-4 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
                          ) : (
                            <Plus className="h-4 w-4" />
                          )}
                        </Button>
                      </>
                    ) : (
                      <Button
                        className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => handleClick(product, "increase")}
                        disabled={needsSelection && !selectedAddons[product.id] || loadingProducts[product.id]}
                      >
                        {loadingProducts[product.id] ? (
                          <div className="flex items-center gap-2">
                            <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            <span>Agregando...</span>
                          </div>
                        ) : needsSelection && !selectedAddons[product.id] ? (
                          "Selecciona una opción"
                        ) : (
                          "Agregar"
                        )}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default ProductList;